export default __webpack_public_path__ + "static/media/header_paper_xs.d4d6a93a.webp";